
import { Tooltip } from 'antd';

const columns = (onPlayerClick) => [
  {
    title: 'Player',
    dataIndex: ['user', 'firstName'],
    key: 'firstName',
    render: (text, record) => {
      const playerName = `${record.user.firstName} ${record.user.lastName}`;
      if (onPlayerClick) {
        return (
          <Tooltip title={`Show ${playerName} game history`}>
            <a
              onClick={(e) => {
                e.preventDefault();
                // Pass the full player object with id and user info
                onPlayerClick({
                  id: record.id || record.playerId,
                  firstName: record.user.firstName,
                  lastName: record.user.lastName,
                  armyName: record.faction?.name,
                  armyListObjectId: record.listId
                });
              }}
              href="#"
            >
              {playerName}
            </a>
          </Tooltip>
        );
      }
      return playerName;
    },
    width: '250px',
  },
  {
    title: 'Army',
    dataIndex: ["faction", "name"],
    key: 'army',
  },
  {
    title: 'List',
    key: 'listId',
    dataIndex: 'listId',
    width: '65px',
    render: (text) => {
      return <a target="_BLANK" href={`https://bestcoastpairings.com/list/${text}`} rel="noreferrer">List</a>
    }
  }
];

export { columns };
